// extracted by mini-css-extract-plugin
export default {"decision":"styles_decision__Qniu3","decision__actions":"styles_decision__actions__daD-k"};